import PropTypes from "prop-types"
import React from "react"

import { useTracker } from "src/hooks/use_tracker"

const SignInCard = ({ copy, marina, quoteId, signInUrl }) => {
  const tracker = useTracker()

  const handleSignIn = () => {
    tracker.trackEvent("contracts_v2:sign_in_to_view_pressed", {
      contract_quote_id: quoteId,
      marina_id: marina.id,
      marina_name: marina.name,
    })
  }

  return (
    <div className="max-w-xl rounded-lg border border-gray-300 bg-white p-6">
      <h2 className="m-0 text-2xl font-bold text-gray-900">{copy.title}</h2>
      <p className="mb-6 mt-2 text-gray-700">{copy.body}</p>
      <a
        className="btn btn-primary w-full"
        href={signInUrl}
        onClick={handleSignIn}
      >
        {copy.cta}
      </a>
    </div>
  )
}

SignInCard.propTypes = {
  copy: PropTypes.shape({
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    cta: PropTypes.string.isRequired,
  }).isRequired,
  marina: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  quoteId: PropTypes.string.isRequired,
  signInUrl: PropTypes.string.isRequired,
}

export default SignInCard
